import type { PreOrderStatus } from '../types';

export const PRE_ORDER_STATUS_LABELS: Record<PreOrderStatus, string> = {
  pending: 'Bekliyor',
  fulfilled: 'Tamamlandı',
  cancelled: 'İptal edildi',
};

export function hasPendingPreOrder(
  preOrders: { productId: number; status: PreOrderStatus }[],
  productId: number,
): boolean {
  return preOrders.some(
    (item) => item.productId === productId && item.status === 'pending',
  );
}
